import { formatRevenueCompact } from './formatters'

// A finished quarter's sales against the target it had: a thin bar (full
// once the target is reached) and the percent. Nothing without a target.
export default function QuarterProgress({ actual, target, currency }: {
  actual: number
  target: number | null | undefined
  currency?: string | null
}) {
  if (target == null || target <= 0) return null
  const pct = Math.round((actual / target) * 100)
  const reached = actual >= target
  return (
    <div
      className="mt-1 flex items-center gap-1.5"
      title={`${pct}% of the ${formatRevenueCompact(target, currency)} target`}
    >
      <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-muted">
        <div
          className={`h-full rounded-full ${reached ? 'bg-success/60' : 'bg-primary/40'}`}
          style={{ width: `${Math.min(pct, 100)}%` }}
        />
      </div>
      <span className={`text-[11px] font-normal tabular-nums ${reached ? 'text-success' : 'text-foreground'}`}>{pct}%</span>
    </div>
  )
}
